import React from 'react';
import '../../styles/activities/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id='activitiesMain'>
            <div className="main-content">
                <h1 className="heading">ACTIVITIES</h1>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-1.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">
                            START-UP CELL &amp; INCUBATION CENTRE (SCIC) - ENCOURAGEMENT AWARDS
                        </p>
                        <p className="card-description">...</p>
                        <div>
                            <a href="#link" className="view-btn">
                                View
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-2.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">महिला सशक्तिकरण (WOMEN EMPOWERMENT)</p>
                        <p className="card-description">
                            (वित्तीय वर्ष 2021-22 विश्वविधालयों द्वारा महिलाओं के लिए सम्पादित होने
                            वाले आउटरीच/विस्तार गतिविधियों और कार्यक्रमों की रूप रेखा )
                        </p>
                        <div>
                            <a
                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/women-to-be-done_21-22.pdf"
                                target="_blank"
                                rel="noreferrer"
                                className="view-btn"
                            >
                                View
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-3.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">PLANTATION DRIVE</p>
                        <p className="card-description">
                            (Planting one lakh peepal trees in University/ Institutions)
                        </p>
                        <div>
                            <a href="#link" className="view-btn">
                                View
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-4.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">COVID-19 TESTING</p>
                        <p className="card-description">
                            (Covid-19 Testing in Rani Lakshmi Bai Girls Hostel)
                        </p>
                        <div>
                            <a href="#link" className="view-btn">
                                View
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-5.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">MISSION SHAKTI ABHIYAN 2021</p>
                        <p className="card-description">
                            (An Initiative by Uttar Pradesh Government)
                        </p>
                        <div>
                            <Link
                                to="/act-mission-shakti-2021"
                                className="view-btn"
                            >
                                View
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <img
                        src="../assets/images/activities/activity-6.jpg"
                        alt=""
                    />
                    <div className="content">
                        <p className="card-title">SOCIAL &amp; EDUCATIONAL ACTIVITIES</p>
                        <p className="card-description">
                            Social &amp; Educational activities performed by Chaudhary Charan Singh
                            University, Meerut during COVID-19 pandemic
                        </p>
                        <div>
                            <a
                                href="https://drive.google.com/file/d/15u5gX3sUpoLfzEQ_lwg3VMYJvasiDUyu/view?usp=sharing"
                                target="_blank"
                                rel="noreferrer"
                                className="view-btn"
                            >
                                View
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main